import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import dataFlowMonitoringConfigAPI from '../apis/dataFlowMonitoringConfigAPI'
import alertMessage from '../utils/alertMessage'

export default class DataFlowMonitoringConfigStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []

  /*SearchResult start*/
  @observable searchItem = {
    'name': '',
    'type': null,
    'noticeType': '',
    'users': null,
    'enable': null,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await dataFlowMonitoringConfigAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @observable auditLogsUserList = []
  @action
  async getAuditUsers() {
    this.auditLogsUserList = []
    try {
      const response = await dataFlowMonitoringConfigAPI.getAuditUsers()
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.auditLogsUserList = data.filter(c=>c.phone).map(a=>{return {
            ...a,
            "email": a?.email,
            "phone": a?.phone,
            "userId": a?.id,
            "userName": a?.shortName
          }})
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/
  @observable dataSourceList = []

  @action
  async onOptionsAction() {
    this.isFetching = true
    this.dataSourceList = []
    try {
      const response = await dataFlowMonitoringConfigAPI.optionsAction({sourceType: 'DB'})
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.dataSourceList = response.data.data
        } else {
          alertMessage.error(response.data.message)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*add permission*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await dataFlowMonitoringConfigAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          if (response.data?.data?.code !== 0 && response.data?.data?.code !== undefined) {
            alertMessage.error(title === 'edit' ? 'Edit Failed！' + response.data.data?.messageEn : 'Add Failed！' + response.data.data?.messageEn)
          } else {
            alertMessage.success(title === 'edit' ? 'Edit Success！' : 'Add Success！')
            this.onSearchJobAction(this.searchItem)
          }
        } else {
          alertMessage.error(title === 'edit' ? 'Edit Failed！' + response.data?.messageEn : 'Add Failed！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit permission*/
  @observable detailsObj = null

  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await dataFlowMonitoringConfigAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          if (data.dataFlowType === '3') {
            data.inboundCustomer = data.inboundCustomer.split(';')
            data.inboundApiConfigId = data.inboundApiConfigId.split(';')
          }
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*schedule permission*/
  @action
  async onScheduleJobAction(params) {
    this.isFetching = true
    try {
      const response = await dataFlowMonitoringConfigAPI.scheduleAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Schedule Success！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error('Schedule Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  
    /*outbound status*/
    @action
    async onChangeStatus(apiID) {
      this.isFetching = true
      try {
        const response = await dataFlowMonitoringConfigAPI.statusAction(apiID)
        runInAction(() => {
          this.isFetching = false
          // if (response.data.code === 200) {
          if (response.data.code === 0) {
            alertMessage.success('Success！')
            this.onSearchJobAction({
              'name': '',
              'type': null,
              'noticeType': '',
              'users': null,
              'enable': null,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          } else {
            alertMessage.error('Failed！' + response.data.data + '')
          }
        })
      } catch (err) {
        alertMessage.error(err.message)
        runInAction(() => {
          this.isFetching = false
        })
      }
    }

  /*delete permission*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await dataFlowMonitoringConfigAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchJobAction({
            'name': '',
            'type': null,
            'noticeType': '',
            'users': null,
            'enable': null,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('Delete Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'name': this.searchItem.name,
      'type': this.searchItem.type,
      'noticeType': this.searchItem.noticeType,
      'users': this.searchItem.users,
      'enable': this.searchItem.enable,
      'page': pageNo,
      'size': pageSize,
    })
  }

  @action
  async getNameDropdown(params) {
    try {
      const response = await dataFlowMonitoringConfigAPI.getNameDropdown(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.inBoundNameList = response.data.data
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getTextDB(params) {
    try {
      const response = await dataFlowMonitoringConfigAPI.textDB(params)
      runInAction(() => {
        if (response.data.code === 0) {
          alertMessage.success('Test Connection Success！')
        } else {
          alertMessage.error('Test Connection Failed！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }
}
